/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Avatar, Box, List, ListItem, Tooltip } from "@mui/material";
import moment from "moment/moment";
import React from "react";
import { useSelector } from "react-redux";
import { selectUserProfile } from "../../../redux/selectors/user";
import Typography from "../../../components/common/new/Typography/Typography";
import styles from "./style";
// import { stringAvatar } from "../NameInitials/NameInitials";

function RemarksList({ remarks }) {
  const user = useSelector(selectUserProfile);

  if (!remarks || !remarks.length) {
    return null;
  }

  const checkRemarkWrittenByMe = (remark) =>
    user.memberId === remark.createdByUser.memberId;

  return (
    <>
      <Box paddingTop="15px" />
      <div>
        <List style={styles.container}>
          {remarks
            .slice(0)
            .reverse()
            ?.map((remark, index) => {
              const remarkWrittenByMe = checkRemarkWrittenByMe(remark);
              return (
                <>
                  <ListItem
                    ket={index}
                    style={{
                      ...styles.listItem,
                      ...(remarkWrittenByMe ? styles.reverseItem : {}),
                    }}
                  >
                    <Box>
                      <Avatar
                        style={styles.avatar}
                        // {...stringAvatar(remark.createdByUser.fullName)}
                        alt="The house from the offer."
                        src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
                      />
                    </Box>
                    <Tooltip
                      title={`${
                        remark.createdByUser.areaName
                          ? `${remark.createdByUser.areaName} / `
                          : ""
                      }
                      ${
                        remark.createdByUser.clusterName
                          ? `${remark.createdByUser.clusterName} / `
                          : ""
                      }
                      ${
                        remark.createdByUser.zoneName
                          ? `${remark.createdByUser.zoneName} / `
                          : ""
                      }
                      ${
                        remark.createdByUser.regionName
                          ? `${remark.createdByUser.regionName} / `
                          : ""
                      }
                      ${remark.createdByUser.chapterName || ""}
                      ${
                        remark.createdByUser.districtName
                          ? ` / ${remark.createdByUser.districtName}`
                          : ""
                      }
                      ${
                        remark.createdByUser.blockName
                          ? ` / ${remark.createdByUser.blockName}`
                          : ""
                      }`}
                      placement="top"
                    >
                      <Box
                        style={{
                          ...styles.remarkText,
                          ...(remarkWrittenByMe
                            ? styles.reverseRemarkText
                            : {}),
                        }}
                      >
                        <Typography
                          style={{
                            lineHeight: "16px",
                            fontSize: "10px",
                            textTransform: "upperCase",
                            fontWeight: "bold",
                          }}
                          component="p"
                          color="#5E5E5E"
                        >
                          ~{remark.createdByUser.fullName}
                        </Typography>

                        <Typography
                          style={{ lineHeight: "16px", paddingTop: "1rem" }}
                          component="p"
                          variant="mini"
                          color="#000000"
                        >
                          {remark.data.message}
                        </Typography>
                      </Box>
                    </Tooltip>
                  </ListItem>
                  <Box
                    style={{
                      ...styles.time,
                      ...(remarkWrittenByMe ? styles.reverseTime : {}),
                    }}
                  >
                    <Typography variant="mini" color="#5E5E5E">
                      {moment(remark.createdAt).format("Y/M/D, h:mm A") || "-"}
                    </Typography>
                  </Box>
                </>
              );
            })}
        </List>
      </div>
    </>
  );
}

export default RemarksList;
